export const usePreloadImages = () => {
  const imagesToPreload = [
    { src: "/customs/cards/deck/default.jpg", priority: "high" },
    { src: "/customs/cards/deck/blue.jpg", priority: "high" },

    { src: "/customs/background/default.jpg", priority: "auto" },
    { src: "/customs/background/default-black.jpg", priority: "auto" },

    { src: "/animations/win.lottie", priority: "low" },
    { src: "/animations/lose.lottie", priority: "low" },

    { src: "/animations/loader-light.json", priority: "high" },
    { src: "/animations/loader-dark.json", priority: "high" },
    { src: "/animations/stars.json", priority: "high" },

    { src: "/animations/dailyBonus/dailyBackground.lottie", priority: "high" },
    { src: "/animations/dailyBonus/dailyBackground2.lottie", priority: "high" },
    { src: "/animations/dailyBonus/dailyGift.lottie", priority: "high" },
  ]

  imagesToPreload.forEach(({ src, priority }) => {
    const link = document.createElement("link")
    link.rel = "preload"
    link.href = src
    link.as = "image"
    link.setAttribute("fetchpriority", priority)
    document.head.append(link)
  })
}
